<div class="user-selector-container">
  <!-- Trigger Button -->
  <div class="selector-trigger" (click)="popover.toggle($event)">
    <!-- Selected Users Display -->
    <div class="selected-users" *ngIf="selectedCount > 0">
      <div class="user-avatar" *ngFor="let user of getSelectedUsers().slice(0, 3)">
        <img
          [src]="getProfileImage(user)"
          [alt]="user.fullName"
          [title]="user.fullName"
          (error)="$any($event.target).src = getProfileImage({_id:'',fullName:user.fullName,email:'',profileImg:''})"
        />
      </div>
      <span class="more-count" *ngIf="selectedCount > 3">
        +{{ selectedCount - 3 }}
      </span>
      <button
        class="clear-btn"
        *ngIf="selectedCount > 0"
        (click)="clearAll($event)"
        type="button"
        title="Clear all"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Placeholder -->
    <div class="placeholder" *ngIf="selectedCount === 0">
      <i class="pi pi-user"></i>
      <span>{{ placeholder }}</span>
    </div>

    <!-- Add Button -->
    <button class="add-btn" type="button">
      <i class="pi pi-plus"></i>
    </button>
  </div>

  <!-- PrimeNG Popover -->
  <p-popover #popover [appendTo]="'body'" styleClass="user-selector-popover" [baseZIndex]="898989" >
    <div class="popover-content-wrapper">
      <!-- Header with Current User -->
      <div class="popover-header" *ngIf="currentUserId && internalUsers.length > 0">
        <ng-container *ngFor="let user of internalUsers">
          <div
            class="user-item current-user"
            *ngIf="isCurrentUser(user._id)"
            [class.selected]="isSelected(user._id)"
          >
            <div class="user-avatar-circle">
              <img [src]="getProfileImage(user)" [alt]="user.fullName"
                   (error)="$any($event.target).src = getProfileImage({_id:'',fullName:user.fullName,email:'',profileImg:''})" />
              <div class="user-role" *ngIf="user.role">{{ user.role }}</div>
            </div>
            <div class="action-icon" (click)="onIconClick(user._id, $event)">
              <i class="pi pi-check" *ngIf="isSelected(user._id)"></i>
              <i class="pi pi-plus" *ngIf="!isSelected(user._id)"></i>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Search Bar -->
      <div class="search-bar">
        <i class="pi pi-search"></i>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
          placeholder="Search by name or email..."
          class="search-input"
        />
      </div>

      <!-- User List -->
      <div class="user-list">
        <!-- Loading State -->
        <div class="loading-state" *ngIf="isLoading">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading team members...</span>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isLoading && filteredUsers.length === 0">
          <i class="pi pi-users"></i>
          <span>No users found</span>
        </div>

        <!-- Users List -->
        <div class="user-group" *ngIf="!isLoading && filteredUsers.length > 0">
          <div
            class="user-item"
            *ngFor="let user of filteredUsers"
            [class.selected]="isSelected(user._id)"
            [class.current-user]="isCurrentUser(user._id)"
          >
            <div class="user-avatar-circle">
              <img [src]="getProfileImage(user)" [alt]="user.fullName"
                   (error)="$any($event.target).src = getProfileImage({_id:'',fullName:user.fullName,email:'',profileImg:''})" />
            </div>
            <div class="user-info" (click)="onUserInfoClick(user._id, $event)">
              <div class="user-name">{{ user.fullName }} (Me)</div>
              <div class="user-role" *ngIf="user.role || user.email">
                {{ user.role || user.email }}
              </div>
            </div>
            <div class="action-icon" (click)="onIconClick(user._id, $event)">
              <i class="pi pi-check" *ngIf="isSelected(user._id)"></i>
              <i class="pi pi-plus" *ngIf="!isSelected(user._id)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="popover-footer" *ngIf="multiSelect">
        <small class="hint-text" *ngIf="quickSelect">
          Click name to select one • Click + to add multiple
        </small>
        <small class="hint-text" *ngIf="!quickSelect">
          Click to select multiple team members
        </small>
      </div>
    </div>
  </p-popover>
</div>
